import { Box, BoxProps } from "@chakra-ui/react";

interface ProgressBarProps {
    value: number;
    max: number;
    color: string;
}

export function ProgressBar({ value, max, color }: ProgressBarProps) {
    const pct = Math.min((value / max) * 100, 100);
    return (
        <Box w="full" h="6px" bg="gray.100" borderRadius="full" overflow="hidden">
            <Box
                h="full"
                w={`${pct}%`}
                bg={pct > 80 ? "#ef4444" : color}
                borderRadius="full"
                transition="width 0.6s ease"
            />
        </Box>
    );
}

export function Card({ children, ...props }: BoxProps) {
    return (
        <Box
            bg="white"
            borderRadius="20px"
            p={6}
            border="1px solid"
            borderColor="gray.100"
            boxShadow="0 2px 16px rgba(0,0,0,0.05)"
            minW={0}
            {...props}
        >
            {children}
        </Box>
    );
}